import { render, staticRenderFns } from "./PowerGrammarFixView.vue?vue&type=template&id=d372d300&scoped=true"
import script from "./PowerGrammarFixView.vue?vue&type=script&lang=js"
export * from "./PowerGrammarFixView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d372d300",
  null
  
)

export default component.exports